import script from "./payrollReport.vue?vue&type=script&setup=true&lang=js"
export * from "./payrollReport.vue?vue&type=script&setup=true&lang=js"

import "./payrollReport.vue?vue&type=style&index=0&id=3f02ec65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f02ec65"]])

export default __exports__